const LANDING_HOSTS = new Set(['courtclic.com', 'www.courtclic.com']);

const getHostname = (url) => {
  if (!url) return '';

  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return '';
  }
};

export const getAppEntryAttribution = ({ search = '', referrer = '' } = {}) => {
  const query = new URLSearchParams(search);
  const referrerHost = getHostname(referrer);
  const isTaggedLandingEntry =
    query.get('utm_source') === 'courtclic.com' &&
    query.get('utm_campaign') === 'landing_page';

  if (isTaggedLandingEntry || LANDING_HOSTS.has(referrerHost)) {
    return {
      entry_channel: 'landing_page',
      entry_placement: query.get('utm_content') || 'untagged'
    };
  }

  if (!referrer) {
    return {
      entry_channel: 'direct_or_saved',
      entry_placement: 'none'
    };
  }

  if (referrerHost === window.location.hostname.toLowerCase()) {
    return {
      entry_channel: 'app_internal',
      entry_placement: 'none'
    };
  }

  return {
    entry_channel: 'other_referral',
    entry_placement: 'none'
  };
};
